import { useEffect, useState } from "react";
import { ABOUT } from "../../constants/PageTitleConstants";
import { useParams } from "react-router-dom";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { HOME_CRUMB } from "../../constants/BreadcrumConstants";
import { makeGetRequest } from "../../rest/RestService";
import PageNotFound from "../not-found/PageNotFound";
import { GENERIC_PAGE_URL } from "../../constants/APIEndpointConstants";
import { HTMLParserHelper } from "../../helper/HTMLParserHelper";
import { Loader } from "./Loader";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import $ from "jquery";
import { ManageScroll } from "../../helper/ManageScroll";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import { yoastHeaderHelper } from "../../helper/YoastHeaderHelper";
const GenericComponent = () => {
  const { genericPath } = useParams();
  const [titleRef, setTitleRef] = useState();
  let title = genericPath.charAt(0).toUpperCase().concat(genericPath.substr(1));
  const [about, setAbout] = useState({});
  const [loader, setLoader] = useState(true);
  const history = useHistory();
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  useEffect(() => {
    setLoader(true);
    if (hfData?.header) {
      makeGetRequest(`${GENERIC_PAGE_URL}${genericPath}`)
        .then((res) => setAbout(res.data[0]))
        .catch((err) => setAbout({ error: err.message }))
        .finally(() => {
          setLoader(false);
          ManageScroll(history);
        });
    }
  }, [genericPath, title, history, hfData?.header]);
  const pageTitle = about?.title?.rendered;
  const handleClick = (e) => {
    e.target.dataset.target &&
      $("html, body").animate(
        {
          scrollTop: $(`#${e.target.dataset.target}`).offset().top,
        },
        2000
      );
  };
  return (
    <>
      {loader ? (
        <Loader />
      ) : !about?.error &&
        about &&
        Object.keys(about).length !== 0 &&
        !hfError ? (
        <>
          <Header data={hfData} />
          <div className="subject_bg">
            <Helmet>
              about?.yoast_head?
              {yoastHeaderHelper(about?.yoast_head)}:
              <title>{titleRef?.innerText?.concat(ABOUT)}</title>
            </Helmet>
            <div className="container subject_padding">
              {/* WEB-331 - fixing the breadcrumbs title issue using dangerouslySetInnerHTML - added dangerouslySetInnerHTML code in breadcrumb component */}
              <Breadcrumb crumbs={[HOME_CRUMB, { title: pageTitle }]} />
              <div className="subject_intro_text">
                <div className="row author_blog_page">
                  <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12 author_blog_text"
                    onClick={(e) => handleClick(e)}
                  >
                    <h1 ref={(e) => setTitleRef(e)}>
                      {HTMLParserHelper(pageTitle)}
                    </h1>
                    {HTMLParserHelper(
                      about?.acf?.description ?? about?.content?.rendered
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer data={hfData} />
        </>
      ) : (
        <PageNotFound pageError={about?.error} />
      )}
    </>
  );
};

export default GenericComponent;
